import { Outlet, useRouterState } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AppDataProvider } from "./appData";
import { CommandPalette } from "./CommandPalette";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { ToastProvider } from "./toast";

export function Shell() {
  const path = useRouterState({ select: (s) => s.location.pathname });
  const [menu, setMenu] = useState(false);
  const [cmdk, setCmdk] = useState(false);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setCmdk((o) => !o);
      } else if (e.key === "Escape") setMenu(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  // biome-ignore lint/correctness/useExhaustiveDependencies: close the mobile menu and scroll up on navigation
  useEffect(() => {
    setMenu(false);
    window.scrollTo(0, 0);
  }, [path]);

  return (
    <ToastProvider>
      <TooltipProvider delayDuration={120} skipDelayDuration={80}>
        <AppDataProvider fallback={(msg) => <div className="loading">{msg}</div>}>
          <div className="app">
            <Sidebar open={menu} />
            <div className="main">
              <Topbar onMenu={() => setMenu(true)} onSearch={() => setCmdk(true)} />
              <main id="view" key={path} className="enter">
                <Outlet />
              </main>
            </div>
          </div>
          <div className={`scrim${menu ? " on" : ""}`} onClick={() => setMenu(false)} aria-hidden="true" />
          <CommandPalette open={cmdk} onOpenChange={setCmdk} />
        </AppDataProvider>
      </TooltipProvider>
    </ToastProvider>
  );
}
